var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.questionnaire && _vm.questionnaire.questions
    ? _c("div", { staticClass: "h-100 pb-5" }, [
        _c(
          "div",
          {
            staticClass:
              "sticky-top main-content-bg row pb-lg-4 align-middle pr-3 hide",
            attrs: { id: "q-header" }
          },
          [
            _c("h3", { staticClass: "mb-4 col-12 col-lg-10 pr-0" }, [
              _c("i", {
                staticClass: "float-left mr-2",
                class: _vm.questionnaire.is_anonymous
                  ? "fas fa-user-secret "
                  : ""
              }),
              _vm._v(" " + _vm._s(_vm.questionnaire.name))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "save-answer-btn p-3 d-block d-lg-none" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary col-12 col-lg-2",
                    on: {
                      click: function($event) {
                        return _vm.postResponse()
                      }
                    }
                  },
                  [_vm._v("Save Answers")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "btn btn-primary col-12 col-lg-2 d-none d-lg-inline-block",
                on: {
                  click: function($event) {
                    return _vm.postResponse()
                  }
                }
              },
              [_vm._v("Save Answers")]
            ),
            _vm._v(" "),
            _vm._m(0)
          ]
        ),
        _vm._v(" "),
        _vm.questionnaire && _vm.questionnaire.questions
          ? _c(
              "div",
              {
                staticClass: "scroll-panel pb-lg-5 pt-lg-0 mb-4",
                staticStyle: { "transition-delay": "0s" }
              },
              [
                _c("transition-group", { attrs: { name: "slide-up" } }, [
                  _vm.completed &&
                  _vm.completed.length !== _vm.questionnaire.questions.length
                    ? _c(
                        "div",
                        { key: "questions", staticClass: "pb-lg-5" },
                        _vm._l(_vm.questionnaire.questions, function(question) {
                          return _c(
                            "section",
                            {
                              key: "q_" + question.id,
                              staticClass:
                                "question p-3 p-lg-5 text-left mt-4 mt-lg-0 mb-lg-5",
                              class: _vm.completed.includes(question.id)
                                ? "answered"
                                : "",
                              staticStyle: { "transition-delay": "0.4s" },
                              attrs: { id: "q_" + question.id }
                            },
                            [
                              _c(
                                "h5",
                                {
                                  staticClass: "font-italic font-weight-light"
                                },
                                [_vm._v(_vm._s(question.question))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "row mt-3" }, [
                                question.type === "free"
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currenFreeTextAnswer,
                                            expression: "currenFreeTextAnswer"
                                          }
                                        ],
                                        staticClass:
                                          "form-control btn w-100 mt-3",
                                        attrs: {
                                          placeholder:
                                            "Type your answer here..."
                                        },
                                        domProps: {
                                          value: _vm.currenFreeTextAnswer
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.currenFreeTextAnswer =
                                              $event.target.value
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-primary w-100 mt-3",
                                          on: {
                                            click: function($event) {
                                              return _vm.saveResponse({
                                                questionnaire_id:
                                                  _vm.questionnaire.id,
                                                question_id: question.id,
                                                answered:
                                                  _vm.currenFreeTextAnswer
                                              })
                                            }
                                          }
                                        },
                                        [_vm._v("Submit")]
                                      )
                                    ])
                                  : _c(
                                      "div",
                                      { staticClass: "w-100 row p-0 m-0 mt-2" },
                                      _vm._l(question.options, function(
                                        options
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            staticClass: "col-6 mt-3",
                                            class:
                                              _vm.maxOptionLength > 30
                                                ? "col-12"
                                                : ""
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "options btn w-100 btn-light",
                                                attrs: {
                                                  rel: "a_" + options.id,
                                                  id: "a_" + options.id
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.saveResponse({
                                                      questionnaire_id:
                                                        _vm.questionnaire.id,
                                                      question_id: question.id,
                                                      answered: options
                                                    })
                                                  }
                                                }
                                              },
                                              [
                                                options.option != null
                                                  ? _c("span", [
                                                      _vm._v(
                                                        _vm._s(options.option)
                                                      )
                                                    ])
                                                  : _c("img", {
                                                      staticClass:
                                                        "option_icon",
                                                      attrs: {
                                                        src: require("@/assets/icons/" +
                                                          options.questionnaire_icon),
                                                        alt: options.alt_text
                                                      }
                                                    })
                                              ]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    : _c(
                        "div",
                        {
                          key: "Finished",
                          staticClass: "col-12 p-0 mt-5",
                          staticStyle: { "transition-delay": "0.4s" }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "alert alert-success mb-0" },
                            [
                              _vm._v(
                                "\n                        You have completed this survey "
                              ),
                              _c("i", { staticClass: "far fa-thumbs-up" })
                            ]
                          )
                        ]
                      )
                ])
              ],
              1
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-dark w-100 mt-3 ml-3" }, [
      _c("i", {
        staticClass: "fa fa-exclamation-circle mr-2",
        attrs: { "aria-hidden": "true" }
      }),
      _vm._v(
        " Please complete the survey questions below. You must click Save answers for your submission to be received."
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e904efba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e904efba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Questionnaire.vue
// module id = null
// module chunks = 